var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HistoryCurveRefreshCycleEnum } from '../../../../view-data/components/history-curve/general/history-curve-refresh-cycle-enum';
import { SelectDisplayItem } from '../../../shared/select-display-item';
var HisotryCurveRefreshCycle = /** @class */ (function (_super) {
    __extends(HisotryCurveRefreshCycle, _super);
    function HisotryCurveRefreshCycle() {
        var _this = _super.call(this) || this;
        _this.push(new SelectDisplayItem('ThirtyMinutes', HistoryCurveRefreshCycleEnum.ThirtyMinutes), new SelectDisplayItem('SixtyMinutes', HistoryCurveRefreshCycleEnum.SixtyMinutes), new SelectDisplayItem('OneHundredTwentyMinutes', HistoryCurveRefreshCycleEnum.OneHundredTwentyMinutes));
        return _this;
    }
    return HisotryCurveRefreshCycle;
}(Array));
export { HisotryCurveRefreshCycle };
